import { useGetSourcesQuery } from './useLoadSources.generated'

export default function useLoadSources() {
  const { data, loading } = useGetSourcesQuery()
  return loading || !data ? [] : data.sources.map(({ name }) => name)
}
